<template>
  <li class="group h-full the-nav-bar-desktop-item">
    <a :href="item.value"
      :class="item.active ? 'active' : ''"
      class="py-12 h-full flex items-center lg:text-16 px-16 border-b-2 border-transparent desktop-navbar-link">
      <h2 class="font-bold text-base">{{ item.name }}</h2>
    </a>

    <!-- submenu panel -->
    <div v-if="item.children.length > 0" class="group-hover:block the-nav-bar-desktop-item-submenu">
      <div class="container px-20 py-18">
        <ul v-if="hasOneLevel" class="column-4">
          <li v-for="link in item.children.filter((c) => c.enabled)" class="text-14 leading-1.2 mb-8">
            <a :href="link.value" class="link link-supporting hover:text-orange">
              {{ link.name }}
            </a>
          </li>
        </ul>
        <div v-else class="grid grid-cols-4 gap-16">
          <div v-for="subMenu in subMenuItems" class="mr-16 last:mr-0">
            <div class="text-dark-gray text-16 font-bold leading-1.2 mb-20">
              <h3>{{ subMenu.name }}</h3>
            </div>
            <ul>
              <li v-for="subMenuItem in subMenu.children.filter((c) => c.enabled)"
                class="text-14 font-medium leading-1.2 mb-8">
                <a :href="subMenuItem.value" class="link link-supporting hover:text-orange">
                  <h4>{{ subMenuItem.name }}</h4>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>
<script>
export default {
  props: {
    item: Object,
  },

  computed: {
    hasOneLevel() {
      return this.item.children.every((child) => child.children.length === 0);
    },

    subMenuItems() {
      return this.item.children.filter((child) => child.enabled);
    },
  },

  created() {
    this.urlChecker(this.item)
  },

  methods: {
    urlChecker(item) {
      if (item.value.endsWith(window.location.pathname)) {
        this.$set(item, 'active', true)
      } else {
        this.$set(item, 'active', false)
      }
    },
  }
};
</script>

<style scoped>
.desktop-navbar-link {
  position: relative;
}

.desktop-navbar-link:hover {
  color: #ff6700;
}

.desktop-navbar-link:after {
  position: absolute;
  width: 100%;
  opacity: 0%;
  left: 0px;
  bottom: -7px;
  height: 3px;
  transform: translateY(-5px);
  background-color: #ff6700;
}

.desktop-navbar-link:hover:after {
  opacity: 100%;
  content: "";
  transform: translateY(-5px);
}

.active {
  color: #ff6700;
}

.active:after {
  position: absolute;
  width: 100%;
  opacity: 100%;
  content: "";
  left: 0px;
  bottom: -7px;
  height: 3px;
  transform: translateY(-5px);
  background-color: #ff6700;
}
</style>
